import PropTypes from 'prop-types';

export const appPropTypes = PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    agentid: PropTypes.number.isRequired,
    secret: PropTypes.string.isRequired,
    squareLogoUrl: PropTypes.string,
}).isRequired;
